import React from "react";
import { Info } from "./LpIcons";

/**
 * Label + help/error wrapper for any control. Pass the control as children.
 * `info` renders a small info icon after the label (matches the Figma fields).
 */
function LpField({ label, required = false, help, error, info = false, infoTip, htmlFor, className = "", labelExtra, children }) {
  const cls = ["lp-field", className].filter(Boolean).join(" ");
  // `infoTip` implies `info`; uses native title so we don't pull in a tooltip lib.
  const showInfo = info || !!infoTip;
  return (
    <div className={cls}>
      {(label || labelExtra) && (
        <label className="lp-field__label" htmlFor={htmlFor}>
          <span>{label}{required && <span className="required-indicator" aria-hidden="true">*</span>}</span>
          {showInfo && <span className="lp-field__info" title={infoTip || undefined}><Info /></span>}
          {labelExtra}
        </label>
      )}
      {children}
      {error ? (
        <span className="lp-field__error">{error}</span>
      ) : help ? (
        <span className="lp-field__help">{help}</span>
      ) : null}
    </div>
  );
}

export default React.memo(LpField);
